// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__iD9iA","root":"index_root__h5Ebf"};